import React            from 'react';

import ad from '../../assets/images/bcit_logo.jpg'
class HSR extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>

            </div>
        );}
}
export default HSR;
